export const SERIALIZATION_VERSION = 7;
export const SHARE_LINK_VERSION_PARAM = 'v';
export const SHARE_LINK_DATA_PARAM = 'link';
